import { forwardRef } from 'react';
import ValidationInput from '../ValidationInput';
import { DescriptionWrapper, DescriptionText } from './styles';

const DescriptionEdit = forwardRef(({ text, onChange, style }, ref) => {
  return (
    <DescriptionWrapper style={style}>
      <ValidationInput
        ref={ref}
        component={DescriptionText}
        containerStyle={{ width: '100%', height: '100%' }}
        placeholder='Description...'
        value={text}
        name='description'
        onChange={onChange}
        validation={(value) => value.length > 1}
        errorMsg={'Field must contain text longer than 1 char'}
      />
    </DescriptionWrapper>
  );
});

export default DescriptionEdit;
